export default "__VITE_ASSET__CP6V1D9z__"